import request from '@/utils/request'
import baseUrl from '@/api/baseUrl'

export default {

	/**
	 * 屏幕分组列表
	 * @param {page} 第几页
	 * @return {pageSize} 每页数量
	**/
	screenGroupList( params={} ) {
		return request({
	    url: baseUrl + '/screen/group',
	    method: 'GET',
	    params
	  })
	},

	/**
	 * 屏幕分组修改
	**/
	screenGroupEdit(id,data){
		return request({
			url: baseUrl + '/screen/group/'+id,
			method:'PUT',
			data
		})
	},

	/**
	 * 屏幕分组添加
	**/
	screenGroupAdd(data){
		return request({
			url: baseUrl + '/screen/group',
			method:'POST',
			data
		})
	},
	/**
	 * 屏幕分组删除
	**/
	screenGroupDel(id){
		return request({
			url: baseUrl + '/screen/group/'+id,
			method:'DELETE'
		})
	}
}